import React from 'react';
import { connect } from 'react-redux';

import { MediumCenteredContainer } from '@eika/engine-view';
import { Link, LinkType } from '@eika/link';

import { StringKeyValue } from '../../actions/types';
import { AppState } from '../../reducers';
import { CardsReducer } from '../../reducers/cards';
import { ContextReducer } from '../../reducers/context';
import { UserReducer } from '../../reducers/user';
import getReturnLinkKey from '../../util/navUtil';
import InfoBox from '../Messages/InfoBox';

import ApprovedIcon from '../../assets/img/ApprovedIcon.svg';

interface Props {
    context: ContextReducer;
    text: StringKeyValue;
    cards: CardsReducer;
    user: UserReducer;
}

const Receipt = (props: Props) => {
    const { text, cards, user, context } = props;
    const {
        receiptHeader,
        receiptText1,
        receiptText2,
        receiptIncreaseText1,
        receiptIncreaseText2,
        receiptReturnButton,
        receiptInfoBox,
    } = text;
    const { selectedCard } = cards;
    const { hasCard } = selectedCard;
    const returnLink = text[getReturnLinkKey(user, context)];

    return (
        <MediumCenteredContainer>
            <>
                {receiptHeader && (
                    <div className="text-center page-header">
                        <img src={ApprovedIcon} alt={text.receiptHeader} title={text.receiptHeader} />
                        <h1>{text.receiptHeader}</h1>
                    </div>
                )}

                <div>
                    {hasCard ? (
                        <div>
                            {receiptIncreaseText1 && <p>{receiptIncreaseText1}</p>}
                            {receiptIncreaseText2 && <p>{receiptIncreaseText2}</p>}
                        </div>
                    ) : (
                        <div>
                            {receiptText1 && <p>{receiptText1}</p>}
                            {receiptText2 && <p>{receiptText2}</p>}
                        </div>
                    )}

                    <div style={{ height: '30px' }} />
                    {receiptReturnButton && (
                        <div
                            style={{
                                textAlign: 'center',
                                marginBottom: '40px',
                            }}
                        >
                            <Link linkType={LinkType.BUTTON_STANDARD_POSITIVE} href={returnLink}>
                                {receiptReturnButton}
                            </Link>
                        </div>
                    )}
                </div>
                <InfoBox type="info">{receiptInfoBox}</InfoBox>
            </>
        </MediumCenteredContainer>
    );
};

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    context: state.context,
    cards: state.cards,
    user: state.user,
});

export default connect(mapStateToProps)(Receipt);
